// src/components/ui/GalleryCarousel.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Maximize2 } from 'lucide-react';
import Carousel from './Carousel';
import GalleryCard from './GalleryCard';
import { galleryImages } from '../../data/galleryImages';
import { useGallery } from '../../hooks/useGallery';

const GalleryCarousel: React.FC = () => {
  const { openImage, featuredImages } = useGallery();

  return (
    <div className="relative">
      {/* Header */}
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-mauve-900 mb-4">
          Featured Nail Art
        </h2>
        <p className="text-lg text-mauve-600 max-w-2xl mx-auto">
          Explore our most popular designs created in Accra
        </p>
      </div>

      {/* Carousel */}
      <Carousel
        autoPlay={true}
        interval={6000}
        showControls={true}
        showDots={true}
        showArrows={true}
        className="pb-12"
      >
        {featuredImages.map((image) => (
          <div key={image.id} className="px-2">
            <GalleryCard
              image={image}
              onClick={() => openImage(image)}
            />
          </div>
        ))}
      </Carousel>

      {/* View All CTA */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
        className="text-center mt-8"
      >
        <button className="btn-outline inline-flex items-center">
          <Maximize2 size={20} className="mr-2" />
          View Complete Gallery
        </button>
      </motion.div>
    </div>
  );
};

export default GalleryCarousel;
